var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',{attrs:{"include":_vm.aliveComponents}},[_c('router-view',{ref:"pageContainer",staticClass:"page-container",on:{"hook:mounted":_vm.handleMounted,"hook:deactivated":_vm.handleDeactivated,"hook:activated":_vm.handleActivated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }